import { Component, Injector, Input } from "@angular/core";
import { LogBookUser, LogUser } from "ng/src/app/users/shared/user.model";
import { GeneralParameters } from "app/shared/model/request-parameter.model";
import { Observable } from "rxjs";
import { UserService } from "ng/src/app/users/shared/user.service";
import { PagedArray } from "app/shared/model/app.model";
import { QuerySelectorComponent } from "ng/src/app/shared/item-selectors/query-selector/query-selector.component";
import { QuerySelectorType, ViewStringItem } from "ng/src/app/shared/item-selectors/query-selector/query-selector.model";
import { map } from "rxjs/operators";

@Component({
	selector: 'logbook-user-selector[logId]',
	templateUrl: '../shared/item-selectors/query-selector/query-selector.component.html',
	styleUrls: ['../shared/item-selectors/query-selector/query-selector.component.scss'],
	providers: [QuerySelectorComponent.ProviderAccessor(LogbookUserSelectorComponent)]
})
export class LogbookUserSelectorComponent extends QuerySelectorComponent<ViewStringItem<LogBookUser>, LogUser.Query> {
	@Input() logId!: number;
	
	constructor(
		private userService: UserService,
		injector: Injector
	) {
		super(injector);
	}
	
	readonly type = QuerySelectorType.Single;
	idField: keyof ViewStringItem<LogBookUser> = 'id';
	displayField: keyof ViewStringItem<LogBookUser> = 'viewString';
	
	protected constructQuery(query: string): LogUser.Query {
		return {
			logId: this.logId,
			hasHistoricalUser: true,
			sort: ['user.lastName,asc', 'user.firstName,asc'],
			globalUserSearch: query
		};
	}
	
	
	writeValue(val: ViewStringItem<LogBookUser>[] | ViewStringItem<LogBookUser> | null) {
		super.writeValue(val);
		this.value.forEach(item => item.viewString = `${item.firstName} ${item.lastName}`);
	}
	
	protected fetch(query: GeneralParameters): Observable<PagedArray<ViewStringItem<LogBookUser>>> {
		return this.userService.fetchLogUsers(query).pipe(
			map(res => PagedArray.from(res.map(i => this.mapItem(i.user)), res.page))
		)
	}
	
	private mapItem(item: LogBookUser): ViewStringItem<LogBookUser> {
		return {
			viewString: `${item.firstName} ${item.lastName}`,
			...item
		}
	}
}
